import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { environmentAtom } from '@root/shared'

import { getEmbeddedPolicyUrl } from '../model'

import type { SettingScreenPolicy } from '../atoms'

type SettingsAboutTheAppProps = {
  policy: SettingScreenPolicy
}

export const SettingsAboutTheApp: React.FC<SettingsAboutTheAppProps> = ({
  policy,
}) => {
  const [env] = useAtom(environmentAtom)

  const policyUrl = getEmbeddedPolicyUrl(env.policiesHost, policy)

  return (
    <Root>
      <IFrame src={policyUrl} loading="eager" />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  position: relative;

  background: var(--appearance-1);
`

const IFrame = styled.iframe`
  all: unset;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;

  background: var(--appearance-1);

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge, and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari, and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`
